import { render, staticRenderFns } from "./CardTabFluxoCaixa.vue?vue&type=template&id=eda4f2da&"
import script from "./CardTabFluxoCaixa.vue?vue&type=script&lang=ts&"
export * from "./CardTabFluxoCaixa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports